import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    font-family: 'Roboto', 'Arial', sans-serif;
  }

  body {
    margin: 0;
  }
  
  html, body, #root {
    height: 100%;
  }
`;

export default GlobalStyle;
